import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
} from '@material-ui/core';
import { WarningOutlined } from '@material-ui/icons';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';

const useStyles = makeStyles({
  row: {
    padding: '2px',
  },
  header: {
    fontWeight: 600,
    fontSize: '16px',
  },
  value: {
    wordBreak: 'break-word',
  },
  mismatchOld: {
    color: '#B92727',
  },
  mismatchNew: {
    color: '#096B40',
  },
});

export default function RcVahaanDetails({
  isDialogOpen,
  handleClose,
  truckDetailsMismatch,
  truckDetailsMismatchChecked,
  truckSystemData,
  truckVahaanData,
}) {
  const classes = useStyles();

  const systemData = truckSystemData || {};
  const vahaanData = truckVahaanData || {};

  const fields = [
    { label: 'Registration No', key: 'rc_regn_no' },
    { label: 'Registration Date', key: 'rc_regn_dt' },
    { label: 'Registration Valid Upto', key: 'rc_regn_upto' },
    { label: 'Purchase Date', key: 'rc_purchase_dt' },
    { label: 'Owner Name', key: 'rc_owner_name' },
    { label: 'Owner Serial No', key: 'rc_owner_sr' },
    { label: 'Owner Category', key: 'rc_own_catg_desc' },
    { label: 'Registered At', key: 'rc_registered_at' },
    { label: 'Blacklist Status', key: 'rc_blacklist_status' },
    { label: 'Present Address', key: 'rc_present_address' },
    { label: 'Permanent Address', key: 'rc_permanent_address' },
    { label: 'Owner Code Description', key: 'rc_owner_cd_desc' },
    { label: 'State Code', key: 'state_cd' },
    { label: 'RTO Code', key: 'rto_cd' },
    { label: 'Office Name', key: 'off_name' },
    {
      label: 'Current Address District Code',
      key: 'rc_currentadd_districtcode',
    },
    { label: 'Status', key: 'rc_status' },
    { label: 'Status As On', key: 'rc_status_as_on' },
    { label: 'Vehicle Category', key: 'rc_vch_catg' },
    { label: 'Vehicle Category Description', key: 'rc_vch_catg_desc' },
    { label: 'Vehicle Class', key: 'rc_vh_class' },
    { label: 'Maker', key: 'rc_maker_desc' },
    { label: 'Maker Code', key: 'rc_maker_cd' },
    { label: 'Model', key: 'rc_maker_model' },
    { label: 'Model Code', key: 'rc_model_cd' },
    { label: 'Fuel Type', key: 'rc_fuel_desc' },
    { label: 'Fuel Code', key: 'rc_fuel_cd' },
    { label: 'Emission Norms', key: 'rc_norms_desc' },
    { label: 'Norms Code', key: 'rc_norms_cd' },
    { label: 'Manufacturing Date', key: 'rc_manu_month_yr' },
    { label: 'No. of Cylinders', key: 'rc_no_cyl' },
    { label: 'Cubic Capacity (cc)', key: 'rc_cubic_cap' },
    { label: 'Wheelbase (mm)', key: 'rc_wheelbase' },
    { label: 'Unladen Weight (kg)', key: 'rc_unld_wt' },
    { label: 'Gross Vehicle Weight (kg)', key: 'rc_gvw' },
    { label: 'Vehicle Type', key: 'rc_vh_type' },
    { label: 'Vehicle Class Description', key: 'rc_vh_class_desc' },
    { label: 'No. of Axles', key: 'rc_no_of_axle' },
    { label: 'Seating Capacity', key: 'rc_seat_cap' },
    { label: 'Sleeper Capacity', key: 'rc_sleeper_cap' },
    { label: 'Sale Amount (INR)', key: 'rc_sale_amt' },
    { label: 'Chassis No', key: 'rc_chasi_no' },
    { label: 'Engine No', key: 'rc_eng_no' },
    { label: 'Body Type', key: 'rc_body_type_desc' },
    { label: 'Color', key: 'rc_color' },
    { label: 'Permit No', key: 'rc_permit_no' },
    { label: 'Permit Issue Date', key: 'rc_permit_issue_dt' },
    { label: 'Permit Valid From', key: 'rc_permit_valid_from' },
    { label: 'Permit Valid Upto', key: 'rc_permit_valid_upto' },
    { label: 'Permit Code', key: 'rc_permit_code' },
    { label: 'Permit Type', key: 'rc_permit_type' },
    { label: 'Permit Category', key: 'rc_permit_catg' },
    { label: 'Fitness Valid Upto', key: 'rc_fit_upto' },
    { label: 'Tax Valid Upto', key: 'rc_tax_upto' },
    { label: 'Financer', key: 'rc_financer' },
    { label: 'Insurance Company', key: 'rc_insurance_comp' },
    { label: 'Insurance Policy No', key: 'rc_insurance_policy_no' },
    { label: 'Insurance Valid Upto', key: 'rc_insurance_upto' },
    { label: 'NOC Details', key: 'rc_noc_details' },
    { label: 'NOC Date', key: 'rc_noc_dt' },
    {
      label: 'Vehicle Surrendered To Dealer',
      key: 'rc_vehicle_surrendered_to_dealer',
    },
    { label: 'Owner Name (History)', key: 'owner_name' },
    { label: 'Owner Serial (History)', key: 'owner_sr' },
    { label: 'Non Use Status', key: 'rc_non_use' },
    { label: 'Passenger Tax', key: 'rc_passenger_tax' },
    { label: 'Goods Tax', key: 'rc_goods_tax' },
    { label: 'Tax Mode', key: 'rc_tax_mode' },
  ];

  return (
    <Dialog open={isDialogOpen} fullWidth maxWidth="md" onClose={handleClose}>
      <DialogTitle>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <Typography variant="h6">RC Details Comparison</Typography>

          <p
            style={{
              color: truckDetailsMismatch === 0 ? '#096B40' : '#B92727',
              backgroundColor:
                truckDetailsMismatch === 0 ? '#F4FBF6' : '#FBEEEE',
              padding: '2px',
              border: `1px solid ${
                truckDetailsMismatch === 0 ? '#128750' : '#D32F2F'
              }`,
              borderRadius: '8px',
              display: 'flex',
              alignItems: 'end',
              gap: '5px',
              margin: 0,
              fontSize: '12px',
            }}
          >
            {truckDetailsMismatch === 0 ? (
              <CheckCircleIcon />
            ) : (
              <WarningOutlined />
            )}
            {truckDetailsMismatch === 0
              ? 'Truck RC details verified successfully.'
              : truckDetailsMismatch === 1
              ? 'Truck RC details do not match. Please verify the RC Details.'
              : truckDetailsMismatch === 2
              ? 'ULIP server down: RC details could not be checked.'
              : 'RC details could not be checked.'}
          </p>
        </div>
      </DialogTitle>

      <DialogContent dividers>
        {truckDetailsMismatch === 0 || truckDetailsMismatch === 1 ? (
          <Grid container spacing={1}>
            <Grid item xs={4} className={classes.header}>
              Field
            </Grid>
            <Grid item xs={4} className={classes.header}>
              Approved System Data
            </Grid>
            <Grid item xs={4} className={classes.header}>
              Latest Data
            </Grid>

            {fields.map(field => {
              const value1 = systemData[field.key] || '-';
              const value2 = vahaanData[field.key] || '-';

              const normalize = val =>
                String(val || '')
                  .trim()
                  .toLowerCase();

              const isDifferent = normalize(value1) !== normalize(value2);

              return (
                <React.Fragment key={field.key}>
                  <Grid item xs={4} className={classes.row}>
                    <Typography>{field.label}</Typography>
                  </Grid>

                  <Grid item xs={4} className={classes.row}>
                    <Typography
                      className={`${classes.value} ${
                        isDifferent ? classes.mismatchOld : ''
                      }`}
                    >
                      {value1}
                    </Typography>
                  </Grid>

                  <Grid item xs={4} className={classes.row}>
                    <Typography
                      className={`${classes.value} ${
                        isDifferent ? classes.mismatchNew : ''
                      }`}
                    >
                      {value2}
                    </Typography>
                  </Grid>
                </React.Fragment>
              );
            })}
          </Grid>
        ) : (
          <Grid item xs={12} style={{ textAlign: 'center' }}>
            <Typography>No Data Available for Comparision</Typography>
          </Grid>
        )}
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose} variant="contained">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}
